import React from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card.jsx';

function SummaryItem({ label, value }) {
  return (
    <div className="rounded-[24px] border border-ptcm-border bg-ptcm-panel/55 p-4 dark:border-gray-800 dark:bg-gray-800/50">
      <div className="text-xs font-medium uppercase tracking-[0.14em] text-ptcm-muted dark:text-gray-400">
        {label}
      </div>
      <div className="mt-2 text-lg font-semibold text-ptcm-ink dark:text-gray-100 break-words">
        {value}
      </div>
    </div>
  );
}

export default function ProfileInfoSectionCard({ title, description, items, onEdit }) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-4">
          <div>
            <CardTitle className="text-base">{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <Button variant="outline" size="sm" onClick={onEdit}>
            Modifier
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {items.map((item) => (
            <SummaryItem key={item.label} label={item.label} value={item.value} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
